import {
  Button,
  Card,
  Col,
  Modal,
  Row,
  Space,
  Typography,
  Table,
  Input,
  InputRef,
  TableColumnType,
  Select,
  Tag,
  Divider,
  Statistic,
  StatisticProps,
  Dropdown
} from "antd";

import ChartBar from "../../../../components/ChartBar";
import { useAppSelector } from "../../../../utils/hooks/hooks";


import { useEffect, useState, useRef } from "react";
import { RootState } from "../../../../store/app";
import { TreemapScriptableContext } from "chartjs-chart-treemap";
import { useNavigate } from "react-router-dom";
import { ArrowsAltOutlined, DownloadOutlined, EllipsisOutlined, FilterOutlined, InfoCircleOutlined, PushpinOutlined, SearchOutlined, ShrinkOutlined, UndoOutlined } from '@ant-design/icons';

import type { FilterDropdownProps } from 'antd/es/table/interface';
import React from "react";
import CountUp from './CountUp';
import InfiniteTypingEffect from './InfiniteTypingEffect';
import SVGIcon from "../../../../utils/SVGIcon";
import Config from "../../../../config/Config";


import CardChart from "./CardChart"
import { ChartConstants } from "../utils/constants";
import UserDetailsModal from "./UserDetailsModal";
import { size } from "lodash";
const { Paragraph, Text } = Typography;

const DashboardCharts: React.FC<any> = ({ chart_js_data, onGraphClick, onReset, setGraphModalObject, downloadExcel, role }) => {
  const [chartDataSets, setChartDataSets] = useState<any>([]);






  const [totalGenders, setTotalGenders] = useState<number>(0);
  const [isRender, setIsRender] = useState<boolean>(false);
  const [data6, setData6] = useState();
  const [data6Loaded, setData6Loaded] = useState(false);
  const userDetail = useAppSelector((state: RootState) => state.auth.userDetail);
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [tableZoomIndex, setTableZoomIndex] = useState<any>(null)

  const [selectedCareerPathwaysValue, setSelectedCareerPathwaysValue] = useState<any>(0)
  const [selectedCareerPathways, setSelectedCareerPathways] = useState<any>(0)

  useEffect(() => {
    if (userDetail != null) {
      setIsLoaded(true);
    }
  }, [userDetail]);
  useEffect(() => {
    setSelectedCareerPathways(chart_js_data?.career_path_ways[selectedCareerPathwaysValue]);
  }, [selectedCareerPathwaysValue]);


  function splitLabelToFit(
    label: string,
    maxWidth: number,
    ctx: TreemapScriptableContext
  ) {
    const words = label.split(" ");
    const lines = [];
    let currentLine = "";
    for (let i = 0; i < words.length; i++) {
      const word = words[i];
      const newLine = currentLine + " " + word;
      const width = ctx.chart.ctx.measureText(newLine).width;
      if (width < maxWidth) {
        currentLine = newLine;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    }
    lines.push(currentLine);
    return lines;
  }



  useEffect(() => {
    if (isRender) {
      const loadData = async () => {
        const borderRadius = 5;
        const chart_career_category = {
          labels: chart_js_data?.career_categories?.map(
            (element: any) => element.code
          ),
          object: chart_js_data?.career_categories?.map(
            (element: any) => element
          ),
          datasets: [
            {
              label: "Number of users",
              data: chart_js_data?.career_categories?.map(
                (element: any) => element.total
              ),

              backgroundColor: (context: any) => {
                const chart = context.chart;
                const chartArea = chart.chartArea;
                if (!chartArea) {
                  return 'rgba(0,0,0,0)'; // Return transparent or a default color
                }
                if (chart_js_data?.career_categories) {
                  const categoryCode = chart_js_data?.career_categories[context.dataIndex]?.industry_id;

                  if (categoryCode == '1') {

                    const solarColors = [
                      "#2E8B57",
                      "#2E8B57",
                      "#2E8B57",
                      "#2E8B57",
                      "#2E8B57",
                      "#2E8B57",
                    ];
                    return solarColors[context.dataIndex % solarColors.length];

                  } else if (categoryCode == '3') {
                    const windColors = [
                      "#4169E1",
                      "#4169E1",
                      "#4169E1",
                      "#4169E1",
                      "#4169E1",
                      "#4169E1",
                    ];
                    return windColors[context.dataIndex % windColors.length];

                  }
                }
                const defaultColors = [
                  "rgba(24, 78, 119, 1)",
                  "rgba(30, 96, 145, 1)",
                  "rgba(26, 117, 159, 1)",
                  "rgba(52, 160, 164, 1)",
                  "rgba(82, 182, 154, 1)",
                  "rgba(118, 200, 147, 1)",
                ];
                // Use modulo operator to cycle through default colors
                return defaultColors[context.dataIndex % defaultColors.length];
              },
              borderRadius: borderRadius,
              hoverOffset: 4,
            },
          ],
        };

        const chart_skill_category_2 = {
          labels: chart_js_data?.skill_categories?.map(
            (element: any) => element.code
          ),
          datasets: [
            {
              label: "Number of users",
              data: chart_js_data?.skill_categories?.map(
                (element: any) => element.total
              ),
              borderColor: 'rgb(75, 192, 192)',
              backgroundColor: [
                "rgba(24, 78, 119, 1)",
                "rgba(30, 96, 145, 1)",
                "rgba(26, 117, 159, 1)",
                "rgba(52, 160, 164, 1)",
                "rgba(82, 182, 154, 1)",
                "rgba(118, 200, 147, 1)",
              ],
              hoverOffset: 4,
              borderRadius: borderRadius,
              pointStyle: 'circle',
              pointRadius: 8,
              pointHoverRadius: 15,
            },
          ],
        };

        const chart_military_status = {
          labels: chart_js_data?.military_status?.map(
            (element: any) => element.name
          ),
          datasets: [
            {
              // barThickness: 40,
              label: "Number of users",
              borderRadius: borderRadius,
              data: chart_js_data?.military_status?.map(
                (element: any) => element.user_count
              ),
              backgroundColor: ["rgba(0, 131, 203, 1)"],
            },
          ],
        };

        const sortedEthnicities =
          chart_js_data?.ethnicities
            ?.slice()
            .sort((a: any, b: any) => b.user_count - a.user_count) || [];

        const treeMapData = sortedEthnicities.map((element: any) => {
          return { category: element.name, "Number of users": element.user_count };
        });


        const chart_ethinicity_data = {
          datasets: [
            {
              tree: treeMapData,
              label: "My Ethnicities Dataset",
              borderColor: "green",
              spacing: 1,
              borderRadius: borderRadius,

              backgroundColor: (ctx: TreemapScriptableContext) => {
                const colors = [
                  "rgba(24, 78, 119, 1)",
                  "rgba(26, 117, 159, 1)",
                  "rgba(22, 138, 173, 1)",
                  "rgba(30, 96, 145, 1)",
                  "rgba(52, 160, 164, 1)",
                  "rgba(82, 182, 154, 1)",
                  "rgba(118, 200, 147, 1)",
                  "rgba(153, 217, 140, 1)",
                  "rgba(153, 217, 140, 1)",
                ];

                return colors[ctx.dataIndex % colors.length];
              },

              key: "Number of users",
              groups: ["category"],
              labels: {
                display: true,
                formatter: (ctx: TreemapScriptableContext) => {
                  return splitLabelToFit(
                    String(ctx.raw.g),
                    ctx.raw.w * 0.9,
                    ctx
                  );
                },
                color: "White",
              },
            },
          ],
        };

        const certificationsFilterd = chart_js_data?.certifications?.filter(
          (element: any) => element.total > 0
        )

        const chart_house_hold_income_data = {
          labels: chart_js_data?.household?.map(
            (item: any) => item.name
          ),
          datasets: [
            {
              label: "Number of users",
              borderRadius: borderRadius,
              data: chart_js_data?.household?.map(
                (item: any) => item.count
              ),
              backgroundColor: [
                "rgba(24, 78, 119, 1)",
                "rgba(30, 96, 145, 1)",
                "rgba(26, 117, 159, 1)",
                "rgba(52, 160, 164, 1)",
                "rgba(82, 182, 154, 1)",
                "rgba(118, 200, 147, 1)",
              ],
            },
          ],
        };

        const chart_disablity_data = {
          labels: chart_js_data?.disabilities?.map(
            (obj: any) => obj.name
          ),
          datasets: [
            {
              label: "Number of users",
              borderRadius: borderRadius,
              data: chart_js_data?.disabilities?.map(
                (obj: any) => obj.count
              ),
              backgroundColor: [
                "rgba(24, 78, 119, 1)",
                "rgba(118, 200, 147, 1)",
              ],
            },
          ],
        };

        const shortedAges = Object.keys(chart_js_data?.age_group).sort((a: any, b: any) => {
          return a.split('-')[0] - b.split('-')[0]
        }).map((key: any) => {
          return { name: key, val: chart_js_data?.age_group[key] }
        })

        const chart_age_group_data = {
          labels: shortedAges?.map(
            (object: any) => object.name
          ),
          datasets: [
            {
              label: "Number of users",
              borderRadius: borderRadius,
              data: shortedAges?.map(
                (object: any) => object.val
              ),
              backgroundColor: [
                "rgba(24, 78, 119, 1)",
                "rgba(26, 117, 159, 1)",
                "rgba(82, 182, 154, 1)",
                "rgba(52, 160, 164, 1)",
                "rgba(30, 96, 145, 1)",
                "rgba(118, 200, 147, 1)",

              ],
            },
          ],
        };



        const educationArray = Object.entries(chart_js_data?.education_level).map(([level, count]) => ({
          level: level.trim(),
          count: count
        }));
        const entries = chart_js_data?.education_level?.reverse();

        const edulevels = entries;

        let chart_education_level_data = {
          labels: edulevels != null ? edulevels.map((item: any) => item.name) : [],
          datasets: [
            {
              label: "Number of users",
              borderRadius: borderRadius,
              data: edulevels != null ? edulevels.map((item: any) => item.user_count) : [],
              backgroundColor: edulevels != null ? edulevels?.map(
                (element: any, i: any) => "rgba(118, 200, 147)"
              ) : [],
            },
          ],
        };
        const chart_gender = {
          labels: chart_js_data?.gender?.map((item: any) => item.name) || [],
          datasets: [
            {
              label: "Number of users",
              borderRadius: borderRadius,
              data: chart_js_data?.gender?.map((item: any) => item.count) || [],
              backgroundColor: [
                "rgba(255, 214, 0, 1)", // Male - Yellow
                "rgba(0, 131, 203, 1)", // Female - Blue
                "rgba(0, 143, 32, 1)", // Other - Green
                "rgba(0, 32,143, 1)", // Other - Green
              ],
              borderWidth: 1,
            },
          ],
        }



        const chart_experience_levels = {
          labels: chart_js_data?.experience_level?.map((item: any) => item.name) || [],
          datasets: [
            {
              label: "Number of users",
              borderRadius: borderRadius,
              data: chart_js_data?.experience_level?.map((item: any) => item.user_count) || [],
              backgroundColor: [
                "rgba(24, 78, 119, 1)",
                "rgba(30, 96, 145, 1)",
                "rgba(26, 117, 159, 1)",
                "rgba(52, 160, 164, 1)",
                "rgba(82, 182, 154, 1)",
                "rgba(118, 200, 147, 1)",
              ],
              borderWidth: 1,
            },
          ],
        }
        setTimeout(() => {
          const chart_zip_code_users = chart_js_data?.zip_code_users;
          const chart_bubble_zip_code_users = chart_js_data?.bubble_zip_code_users.map((item: any) => {
            let value = item.zipcode;
            item.zipcode = item.state;
            item.state = value;
            return item;
          });
          // setSelectedCareerPathwaysValue(0);
          setSelectedCareerPathways(chart_js_data?.career_path_ways[selectedCareerPathwaysValue || 0]);
          setChartDataSets({ chart_career_category, chart_gender, chart_experience_levels, chart_skill_category_2, chart_military_status, chart_ethinicity_data, chart_house_hold_income_data, chart_disablity_data, chart_age_group_data, chart_education_level_data, chart_zip_code_users, chart_bubble_zip_code_users });
        }, 1000);
      };
      loadData();

      /*
       * Set the data for the zip code chart after the data is loaded for all other charts
       * because of loading issue with zip code chart
       */

    }
    setIsRender(true);

  }, [chart_js_data]);
  // console.log(chartDataSets);



  const [chartType, setChartType] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef<InputRef>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps['confirm'],
    dataIndex: any,
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };


  const getColumnSearchProps = (dataIndex: any, title: any): TableColumnType => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${title}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            type="default"
            size="large"
            onClick={() => {
              clearFilters && clearFilters();
              setSearchText('');
              confirm({ closeDropdown: false });
              close();
              setSearchedColumn(dataIndex);
            }}
          >
            Reset
          </Button>


        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
  });

  const columnsCareer: any[] = [

    {
      title: "ID",
      key: 'id',
      fixed: true,
      width: 80,
      sorter: (a: any, b: any) => a.id - b.id,
      render: (item: any) => item.id,
    },
    {
      title: "Name",
      key: 'name',
      field: "name",
      ...getColumnSearchProps('name', 'Name'),
      render: (item: any) => <Paragraph
        ellipsis={{
          rows: 2,
          expandable: 'collapsible',
          symbol: ((expanded: boolean) => expanded ? 'Read less' : 'Read more')

        }}>
        {item.name}
      </Paragraph>,
    },
    {
      title: "Total Users",
      align: 'center',
      width: 80,
      key: 'total',
      field: "total",
      sorter: (a: any, b: any) => a.total - b.total,
      render: (item: any) => <Tag color="geekblue">{item.total}</Tag>,

    },
    {
      title: 'Action',
      key: 'action',
      width: 30,
      render: (_: any, record: any) => (
        <Button color="blue" onClick={() => onGraphClick({ graph_key: ChartConstants.careers.key, graph_label_value: record.name })} icon={<FilterOutlined />} size="small" />
      ),
    },
  ];


  const columnsCirtification: any[] = [

    {
      title: "ID",
      key: 'id',
      fixed: true,
      width: 80,
      sorter: (a: any, b: any) => a.id - b.id,
      render: (item: any) => item.id,
    },
    {
      title: "Short Form",
      key: 'short_form',
      width: 350,
      // width: 200,
      field: "short_form",
      ...getColumnSearchProps('short_form', 'Short Form'),
      render: (item: any) => item.short_form,
    },
    {
      title: "Total Users",
      align: 'center',
      key: 'total',
      field: "total",
      sorter: (a: any, b: any) => a.total - b.total,
      render: (item: any) => <Tag color="geekblue">{item.total}</Tag>,

    },
    {
      title: 'Action',
      key: 'action',
      width: 30,
      render: (_: any, record: any) => (
        <Button color="blue" onClick={() => onGraphClick({ graph_key: ChartConstants.certifications.key, graph_label_value: record.short_form })} icon={<FilterOutlined />} size="small" />
      ),
    },
  ];



  const formatter: StatisticProps['formatter'] = (value) => (
    <CountUp start={0.00} end={value as number} />
  );




  const graphClickEvent = (e: any, legendItem: any, Chart: any) => {

    if (legendItem.length == 0) return;
    const index = legendItem[0].index;

    const graph_key = Chart.config.options.customChartType;
    let graph_label_value: any;
    graph_label_value = Chart.config.data.labels[index];
    if (graph_key == 'ethnicities') {
      graph_label_value = Chart?.config?.data?.datasets[0]?.tree[index]?.category || null;
    }
    console.log(Chart.config, { graph_key, graph_label_value })
    onGraphClick({ graph_key, graph_label_value });

  }

  const items: any = [
    {
      key: 'export',
      label: 'Export',
      icon: <DownloadOutlined />
    },
    {
      type: 'divider',
    },
    {
      key: 'view-users',
      label: 'View Users',
      icon: <InfoCircleOutlined />
    },
    {
      key: 'reset',
      label: 'Reset',
      icon: <UndoOutlined />
    },
  ];


  const itemsCombine: any = [
    {
      key: 'export',
      label: 'Export',
      icon: <DownloadOutlined />,
      children: [
        {
          key: 'gender-export',
          label: 'Gender',
        },
        {
          key: 'disability-export',
          label: 'Disability',
        },
      ],
    },
    {
      type: 'divider',
    },
    {
      key: 'view-users',
      label: 'View Users',
      icon: <InfoCircleOutlined />,
      children: [
        {
          key: 'gender-view-users',
          label: 'Gender',
        },
        {
          key: 'disability-view-users',
          label: 'Disability',
        },
      ],
    },
    {
      key: 'reset',
      label: 'Reset',
      icon: <UndoOutlined />
    },
  ];




  const UsersSvg = () => <>
    <svg width="37" height="26" viewBox="0 0 37 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.55 11.1429C7.59078 11.1429 9.25 9.47723 9.25 7.42857C9.25 5.37991 7.59078 3.71429 5.55 3.71429C3.50922 3.71429 1.85 5.37991 1.85 7.42857C1.85 9.47723 3.50922 11.1429 5.55 11.1429ZM31.45 11.1429C33.4908 11.1429 35.15 9.47723 35.15 7.42857C35.15 5.37991 33.4908 3.71429 31.45 3.71429C29.4092 3.71429 27.75 5.37991 27.75 7.42857C27.75 9.47723 29.4092 11.1429 31.45 11.1429ZM33.3 13H29.6C28.5825 13 27.6633 13.4121 26.9927 14.0795C29.3225 15.3621 30.9759 17.6777 31.3344 20.4286H35.15C36.1733 20.4286 37 19.5987 37 18.5714V16.7143C37 14.6656 35.3408 13 33.3 13ZM18.5 13C22.0786 13 24.975 10.0924 24.975 6.5C24.975 2.90759 22.0786 0 18.5 0C14.9214 0 12.025 2.90759 12.025 6.5C12.025 10.0924 14.9214 13 18.5 13ZM22.94 14.8571H22.4602C21.2577 15.4375 19.9222 15.7857 18.5 15.7857C17.0778 15.7857 15.7481 15.4375 14.5398 14.8571H14.06C10.3831 14.8571 7.4 17.8518 7.4 21.5429V23.2143C7.4 24.7522 8.64297 26 10.175 26H26.825C28.357 26 29.6 24.7522 29.6 23.2143V21.5429C29.6 17.8518 26.6169 14.8571 22.94 14.8571ZM10.0073 14.0795C9.33672 13.4121 8.4175 13 7.4 13H3.7C1.65922 13 0 14.6656 0 16.7143V18.5714C0 19.5987 0.826719 20.4286 1.85 20.4286H5.65984C6.02406 17.6777 7.6775 15.3621 10.0073 14.0795Z" fill="white" />
    </svg>
  </>

  const onClickTable: any = ({ key }: any, object: any) => {
    console.log(key, object)
    if (key == 'view-users') {
      setGraphModalObject(object)
    }
    else if (key.includes('export')) {
      downloadExcel(object)
    }
    else if (key == 'reset') {
      onReset();
    }
  };


  let responsive = role == 'admin' ? { xxl: 4, lg: 8, md: 12, sm: 24 } : { xxl: 6, lg: 8, md: 12, sm: 24 };
  let colorClass = (index: any) => {
    if (index % 3 == 1) {
      return 'metric-card-blue';
    }
    else if (index % 3 == 2) {
      return 'metric-card-green';
    }
    else if (index % 3 == 0) {
      return 'metric-card-purple';
    }
  };

  return (<>
    {
      isLoaded ? <>

        <Row className="dashboard-statistic-row" gutter={[15, 15]} >
          <Col xxl={24} lg={24} md={24}>
            <Row gutter={[15, 15]} >
              <Col {...responsive} >
                <Card className={"metric-card " + colorClass(1)} >
                  <div className="metric-content">
                    <div className="metric-info">
                      <h4>Total Users</h4>
                      {/* <Statistic value={chart_js_data?.total_active_user || 0} precision={2} formatter={formatter} /> */}
                      <InfiniteTypingEffect textArray={[`Active: ${chart_js_data?.total_active_user || 0} `, `Expired: ${chart_js_data?.total_expire_user || 0}`]} typingSpeedMs={40} />

                    </div>
                    <div className="metric-icon">
                      <UsersSvg />
                    </div>
                  </div>
                </Card>
              </Col>
              {role == 'admin' &&
                <>
                  <Col {...responsive} >
                    <Card className={"metric-card " + colorClass(2)} >
                      <div className="metric-content">
                        <div className="metric-info">
                          <h4>Trial Users</h4>
                          <Statistic value={chart_js_data?.total_trial_user || 0} precision={2} formatter={formatter} />

                        </div>
                        <div className="metric-icon">
                          <UsersSvg />
                        </div>
                      </div>
                    </Card>
                  </Col>
                  <Col {...responsive} >
                    <Card className={"metric-card " + colorClass(3)} >
                      <div className="metric-content">

                        <div className="metric-info">
                          <h4>Trial Completed</h4>
                          <Statistic value={chart_js_data?.trial_completed || 0} precision={2} formatter={formatter} />

                        </div>
                        <div className="metric-icon">
                          <UsersSvg />
                        </div>

                      </div>
                    </Card>
                  </Col>
                </>
              }
              <Col {...responsive} >
                <Card className={"metric-card " + colorClass(role == 'admin' ? 4 : 2)} >
                  <div className="metric-content">

                    <div className="metric-info">
                      <h4>Interest Completed</h4>
                      <Statistic value={chart_js_data?.interest_completed || 0} precision={2} formatter={formatter} />

                    </div>
                    <div className="metric-icon">
                      <UsersSvg />
                    </div>
                  </div>
                </Card>
              </Col>
              <Col {...responsive} >
                <Card className={"metric-card " + colorClass(role == 'admin' ? 5 : 3)} >
                  <div className="metric-content">

                    <div className="metric-info">
                      <h4>Compass Completed</h4>
                      <Statistic value={chart_js_data?.career_compass_completed || 0} precision={2} formatter={formatter} />

                    </div>
                    <div className="metric-icon">
                      <UsersSvg />
                    </div>
                  </div>
                </Card>
              </Col>


              <Col {...responsive} >
                <Card className={"metric-card " + colorClass(role == 'admin' ? 6 : 4)} >
                  <div className="metric-content">

                    <div className="metric-info">
                      <h4>Career Pathways </h4>
                      {/* <h2>{item.value}</h2> */}

                      {/* <Statistic value={10} precision={2} /> */}
                      <InfiniteTypingEffect textArray={[`Users: ${selectedCareerPathways?.user_value || 0}`, `Careers: ${selectedCareerPathways?.career_value || 0}`]} typingSpeedMs={40} />



                    </div>
                    <div className="metric-icon">
                      <Select
                        // defaultValue={0}
                        size="small"
                        value={selectedCareerPathwaysValue}
                        labelInValue
                        // onChange={(val: any) => { setSelectedCareerPathways(chart_js_data?.career_path_ways[val.value] || { career_value: 0, user_value: 0 }) }}
                        onChange={(val: any) => { setSelectedCareerPathwaysValue(val.value) }}
                        options={chart_js_data?.career_path_ways?.map((item: any, index: any) => { return { value: index, label: item.label, selected: item.value } })}
                      />
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>

          </Col>
        </Row>
        <Row className="dashboard-graph-row" gutter={[15, 15]} >
          <Col xxl={6} lg={12} md={24} sm={24}>
            <CardChart items={items} downloadExcel={() => downloadExcel(ChartConstants.career_categories)} onReset={onReset} setGraphModal={() => setGraphModalObject(ChartConstants.career_categories)} title="Career Categories" >
              <ChartBar
                data={chartDataSets?.chart_career_category || []}
                type="bar"
                options={{
                  onClick: graphClickEvent,
                  customChartType: ChartConstants.career_categories.key,

                  plugins: {
                    legend: {
                      display: false,
                    },
                  },
                  scales: {
                    x: {
                      display: true,
                      title: {
                        display: true,
                        text: 'Career Category',
                      }
                    },
                    y: {
                      display: true,
                      title: {
                        display: true,
                        text: 'Number of users',
                      }
                    }
                  }
                }} />
            </CardChart>

          </Col>
          <Col xxl={6} lg={12} md={24} sm={24}> {/* CI */}

            <CardChart items={items} downloadExcel={() => downloadExcel(ChartConstants.skill_categories)} onReset={onReset} setGraphModal={() => setGraphModalObject(ChartConstants.skill_categories)} title="Skill Categories">
              <ChartBar data={chartDataSets?.chart_skill_category_2 || []} type="bar" options={{
                onClick: graphClickEvent,
                customChartType: ChartConstants.skill_categories.key,
                plugins: {
                  legend: {
                    display: false,
                  },
                },
                scales: {
                  x: {
                    display: true,
                    title: {
                      display: true,
                      text: 'Skill Category',
                    }
                  },
                  y: {
                    display: true,
                    title: {
                      display: true,
                      text: 'Number of users',
                    }
                  }
                }
              }} />

            </CardChart>
          </Col>
          <Col xxl={6} lg={12} md={24} sm={24}>

            {tableZoomIndex == 10 && <div className="backdrop" onClick={() => setTableZoomIndex(null)} />}

            <Card className={"chart-card chart-card-table " + (tableZoomIndex == 10 ? 'zoomed' : '')} title={'Careers'} extra={
              <>
                <Dropdown menu={{ items, onClick: (prop) => onClickTable(prop, ChartConstants.careers) }} trigger={['click']}>
                  <Button size="large" type="link"><EllipsisOutlined /> </Button>
                </Dropdown>
                <Button onClick={() => setTableZoomIndex((state: any) => state == 10 ? null : 10)} size="large" type="link">
                  {/* <ArrowsAltOutlined /> */}
                  {tableZoomIndex == 10 ? <ShrinkOutlined /> : <ArrowsAltOutlined />}

                </Button>
              </>

            }>
              <Table
                dataSource={chart_js_data?.careers?.filter((item: any) => item.total > 0).filter((item: any, index: number) => tableZoomIndex == 10 ? true : index < 2) || []}
                columns={columnsCareer}
                pagination={tableZoomIndex == 10 ? { defaultPageSize: 5, showSizeChanger: false, position: ['none', 'bottomCenter'] } : false}
                rowKey={(record: any) => 'caree' + record.id}

              />
              {tableZoomIndex != 10 && <Button className="show-more-table" onClick={() => setTableZoomIndex((state: any) => state == 10 ? null : 10)} size="large" type="primary">Show More</Button>}


            </Card>





          </Col>
          <Col xxl={6} lg={12} md={24} sm={24}>
            {tableZoomIndex == 11 && <div className="backdrop" onClick={() => setTableZoomIndex(null)} />}
            <Card className={"chart-card  chart-card-table " + (tableZoomIndex == 11 ? 'zoomed' : '')} title={'Certifications'} extra={
              <>
                <Dropdown menu={{ items, onClick: (prop) => onClickTable(prop, ChartConstants.certifications) }} trigger={['click']}>
                  <Button size="large" type="link"><EllipsisOutlined /> </Button>
                </Dropdown>
                <Button onClick={() => setTableZoomIndex((state: any) => state == 11 ? null : 11)} size="large" type="link">
                  {tableZoomIndex == 11 ? <ShrinkOutlined /> : <ArrowsAltOutlined />}
                </Button>
              </>

            }>
              <Table
                dataSource={chart_js_data?.certifications?.filter((item: any) => item.total > 0).filter((item: any, index: number) => tableZoomIndex == 11 ? true : index < 4) || []}
                columns={columnsCirtification}
                pagination={tableZoomIndex == 11 ? { defaultPageSize: 5, showSizeChanger: false, position: ['none', 'bottomCenter'] } : false}
                rowKey={(record: any) => 'cer' + record.id}
              />
              {tableZoomIndex != 11 && <Button className="show-more-table" onClick={() => setTableZoomIndex((state: any) => state == 11 ? null : 11)} size="large" type="primary">Show More</Button>}

            </Card>
          </Col>


          <Col xxl={6} lg={12} md={24} sm={24}>
            <CardChart
              items={itemsCombine}
              onReset={onReset}
              downloadExcel={(key: any) => downloadExcel(key == 'gender-export' ? ChartConstants.gender : ChartConstants.disabilities)}
              setGraphModal={(key: any) =>
                setGraphModalObject(key == 'gender-view-users' ? ChartConstants.gender : ChartConstants.disabilities) && console.log(key)
              }
              title="Gender & Disability"
            >

              <ChartBar
                className="chart not-height"
                type="bar"
                height={'80rem'}
                width={'200rem'}
                data={chartDataSets?.chart_gender}
                options={{
                  indexAxis: 'y',
                  onClick: graphClickEvent,
                  customChartType: ChartConstants.gender.key,
                  scales: {
                    x: {
                      display: true,
                      title: {
                        display: true,
                        text: 'Gender'
                      }
                    }
                  },
                  plugins: {
                    legend: {
                      position: false,
                    },
                  },
                }}
              />
              <Divider size="small" />

              <ChartBar
                height={'80rem'}
                width={'200rem'}
                className="chart not-height" data={chartDataSets?.chart_disablity_data || []} type="bar" options={{
                  onClick: graphClickEvent,
                  customChartType: ChartConstants.disabilities.key,
                  indexAxis: 'y',
                  scales: {
                    x: {
                      display: true,
                      title: {
                        display: true,
                        text: 'Disability'
                      }
                    }
                  },
                  plugins: {
                    legend: {
                      display: false,
                    },
                  }
                }} />
            </CardChart>

          </Col>

          <Col xxl={6} lg={12} md={24} sm={24}>
            <CardChart items={items}
              downloadExcel={() => downloadExcel(ChartConstants.experience_level)}
              onReset={onReset}
              setGraphModal={() => setGraphModalObject(ChartConstants.experience_level)}

              title="Experience Level" >
              <ChartBar
                className="chart"
                data={chartDataSets?.chart_experience_levels || []}
                type="pie"
                options={{
                  onClick: graphClickEvent,
                  customChartType: ChartConstants.experience_level.key,
                  plugins: {
                    legend: {
                      // display: false,
                      position: "bottom",

                    },
                    tooltip: {
                      callbacks: {
                        label: (context: any) => {
                          let label = context.dataset.label || '';
                          if (label) {
                            label += ': ';
                          }
                          if (context.parsed !== null) {
                            label += context.parsed;
                          }
                          const sum = context.dataset.data.reduce((acc: any, curr: any) => acc + curr, 0);
                          var percent = 0;
                          if (sum > 0) {
                            percent = (context.parsed * 100) / sum;
                          }
                          label += ', Percentage: ' + percent.toFixed(1) + '%';
                          return label;
                        }
                      }
                    }
                  }
                }} />
            </CardChart>

          </Col>
          <Col xxl={6} lg={12} md={24} sm={24}>
            <CardChart items={items}

              downloadExcel={() => downloadExcel(ChartConstants.household)} onReset={onReset}
              setGraphModal={() => setGraphModalObject(ChartConstants.household)}

              title="Household Income" >
              <ChartBar
                className="chart"
                data={chartDataSets?.chart_house_hold_income_data || []} type="doughnut" options={{
                  onClick: graphClickEvent,
                  customChartType: ChartConstants.household.key,
                  plugins: {
                    legend: {
                      // display: false,
                      position: "bottom",

                    },
                    tooltip: {
                      callbacks: {
                        label: (context: any) => {
                          let label = context.dataset.label || '';
                          if (label) {
                            label += ': ';
                          }
                          if (context.parsed !== null) {
                            label += context.parsed;
                          }
                          const sum = context.dataset.data.reduce((acc: any, curr: any) => acc + curr, 0);
                          var percent = 0;
                          if (sum > 0) {
                            percent = (context.parsed * 100) / sum;
                          }
                          label += ', Percentage: ' + percent.toFixed(1) + '%';
                          return label;
                        }
                      }
                    }
                  }
                }} />
            </CardChart>
          </Col>
          <Col xxl={6} lg={12} md={24} sm={24}>


            <CardChart items={items} downloadExcel={() => downloadExcel(ChartConstants.age_group)} onReset={onReset}
              setGraphModal={() => setGraphModalObject(ChartConstants.age_group)}

              title="Age">
              <ChartBar
                className="chart"
                type="doughnut"
                data={{
                  labels: chartDataSets?.chart_age_group_data?.labels || [], // e.g. ['18-25', '26-35', '36-45', '46+']
                  datasets: chartDataSets?.chart_age_group_data?.datasets || [],
                }}
                options={{
                  onClick: graphClickEvent,
                  customChartType: ChartConstants.age_group.key,
                  plugins: {
                    legend: {
                      position: "bottom",
                    },
                    tooltip: {
                      callbacks: {
                        label: (context: any) => {
                          let label = context.label || "";
                          const value = context.parsed || 0;

                          const total = context.dataset.data.reduce(
                            (sum: any, val: any) => sum + val,
                            0
                          );
                          const percentage = total > 0 ? ((value * 100) / total).toFixed(1) : 0;

                          return `${label}: ${value} (${percentage}%)`;
                        },
                      },
                    },
                  },
                }}
              />
            </CardChart>
          </Col>

          <Col xxl={6} lg={12} md={24} sm={24}>
            <CardChart items={items} downloadExcel={() => downloadExcel(ChartConstants.military_status)} onReset={onReset}
              setGraphModal={() => setGraphModalObject(ChartConstants.military_status)}

              title="Military Service">
              <ChartBar
                data={chartDataSets?.chart_military_status}
                name={"Military Status"}
                type="bar"
                options={{
                  onClick: graphClickEvent,
                  customChartType: ChartConstants.military_status.key,
                  indexAxis: 'y',
                  plugins: {
                    legend: {
                      display: false,
                    },
                  },
                  scales: {
                    x: {
                      display: true,
                      title: {
                        display: true,
                        text: 'Number of users',
                      }
                    },
                    y: {
                      display: true,
                      title: {
                        display: true,
                        text: 'Military Status',
                      }
                    }
                  }
                }} />
            </CardChart>
          </Col>


          <Col xxl={6} lg={12} md={24} sm={24}> {/* CI */}

            <CardChart items={items} downloadExcel={() => downloadExcel(ChartConstants.ethnicities)} onReset={onReset}
              setGraphModal={() => setGraphModalObject(ChartConstants.ethnicities)}

              title="Ethnicity">
              <ChartBar
                className="chart"
                data={chartDataSets?.chart_ethinicity_data || []}
                name={"Ethnicities"}
                type="treemap"
                options={{
                  onClick: graphClickEvent,
                  customChartType: ChartConstants.ethnicities.key,
                }}
              />
            </CardChart>

          </Col>

          <Col xxl={6} lg={12} md={24} sm={24}>

            <CardChart items={items} downloadExcel={() => downloadExcel(ChartConstants.education_level)} onReset={onReset}
              setGraphModal={() => setGraphModalObject(ChartConstants.education_level)}

              title="Education">
              <ChartBar
                data={chartDataSets?.chart_education_level_data && chartDataSets?.chart_education_level_data || []}

                type="bar"
                options={{
                  onClick: graphClickEvent,
                  customChartType: ChartConstants.education_level.key,
                  plugins: {

                    legend: {
                      display: false,
                    },
                  },
                  scales: {
                    x: {
                      display: true,

                      title: {
                        display: true,
                        text: 'Education Levels',
                      },
                      ticks: {
                        callback: function (val: any, index: any, d1: any) {
                          // Hide every 2nd tick label
                          let valget = chartDataSets?.chart_education_level_data?.labels[index] || '';
                          return valget ? valget.length > 15 ? (valget.slice(0, 15).trim() + '...') : valget : '';
                        },
                        major: false,
                        font: {
                          size: 11
                        },
                        minRotation: 30, // Sets the minimum rotation to 90 degrees (vertical)
                        maxRotation: 90  // Ensures the rotation remains 90 degrees
                      }
                    },
                    y: {
                      display: true,
                      title: {
                        display: true,
                        text: 'Number of users',
                      }
                    }
                  }
                }}
              />
            </CardChart>

          </Col>

          <Col xxl={6} lg={12} md={24} sm={24}>
            <CardChart
              items={items}
              downloadExcel={() => downloadExcel(ChartConstants.zip_code_users)}
              onReset={onReset}
              setGraphModal={() => setGraphModalObject(ChartConstants.zip_code_users)}

              title="Location" >
              <ChartBar
                className="chart"
                data={chartDataSets?.chart_bubble_zip_code_users || []}
                type="choropleth"
                options={{
                  onClick: graphClickEvent,
                  customChartType: ChartConstants.zip_code_users.key,
                }}

              />
            </CardChart>

          </Col>


        </Row >

      </> : <></>
    }
  </>);

};


export default DashboardCharts;
